import { Text } from "./Text.mjs";
import { Flex } from "./Flex.mjs";
import { Icon } from "./Icon.mjs";
import React from "react";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/Card.tsx
const Card = ({ onClick, icon, title, description, properties, meta, rightText, transition }) => {
	const rightElement = /* @__PURE__ */ jsx(Flex, {
		gap: "xxxs",
		children: rightText ? /* @__PURE__ */ jsx(Text, {
			color: "sand10",
			size: "sm",
			children: rightText
		}) : null
	});
	const hasMeta = meta !== void 0;
	return /* @__PURE__ */ jsxs(Flex, {
		column: true,
		borderRadius: "md",
		borderWidth: "md",
		borderColor: "sandA5",
		background: "sand2",
		padding: "sm",
		gap: "xs",
		onClick,
		transition,
		style: { position: "relative" },
		children: [hasMeta ? /* @__PURE__ */ jsxs(Flex, {
			justify: "space-between",
			children: [/* @__PURE__ */ jsxs(Flex, {
				gap: "xxs",
				align: "center",
				children: [/* @__PURE__ */ jsx(Icon, {
					name: meta.icon,
					color: meta.color,
					size: "sm"
				}), /* @__PURE__ */ jsx(Text, {
					color: meta.color,
					weight: "medium",
					size: "sm",
					children: meta.text
				})]
			}), rightElement]
		}) : null, /* @__PURE__ */ jsxs(Flex, {
			gap: "sm",
			align: "flex-start",
			children: [icon ? /* @__PURE__ */ jsx(Icon, {
				name: icon,
				color: "sand12"
			}) : null, /* @__PURE__ */ jsxs(Flex, {
				column: true,
				flex: true,
				gap: "xxs",
				children: [
					/* @__PURE__ */ jsxs(Flex, {
						justify: "space-between",
						children: [/* @__PURE__ */ jsx(Text, {
							size: "md",
							weight: "semibold",
							children: title
						}), !hasMeta ? rightElement : null]
					}),
					properties && properties.length > 0 ? /* @__PURE__ */ jsx(Flex, {
						column: true,
						gap: "xxxs",
						children: properties.filter((property) => property !== void 0 && property !== null && property !== false).map(({ icon: icon$1, text, color }, index) => /* @__PURE__ */ jsxs(Flex, {
							align: "center",
							gap: "xxs",
							children: [/* @__PURE__ */ jsx(Icon, {
								size: "sm",
								name: icon$1,
								color: color ?? "sand10"
							}), /* @__PURE__ */ jsx(Text, {
								size: "sm",
								color,
								children: text
							})]
						}, index))
					}) : null,
					description ? /* @__PURE__ */ jsx(Text, { children: description }) : null
				]
			})]
		})]
	});
};

//#endregion
export { Card };